import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowUpOnSquareIcon from "@heroicons/react/24/solid/ArrowUpOnSquareIcon";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { CustomersSearch } from "@/sections/customer/customers-search";
import {
  useGetUrlRedirectsQuery,
  useUpdateUrlRedirectMutation,
} from "@/app/features/urlRedirect/urlRedirectApiSlice";
import RedirectListing from "./components/RedirectListing";
import RedirectDeleteModal from "./components/RedirectDeleteModal";
import { toast } from "sonner";

export default function RedirectsPage() {
  const [search, setSearch] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const { data, isLoading, isFetching, error } = useGetUrlRedirectsQuery({
    page: paginationModel.page + 1,
    limit: paginationModel.pageSize,
    search,
  });

  const [updateUrlRedirect] = useUpdateUrlRedirectMutation();
  const [rowCountState, setRowCountState] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    setRowCountState((prev) =>
      data?.data?.total !== undefined ? data.data.total : prev
    );
  }, [data]);

  const handleSelectDelete = (item) => {
    setSelectedItem(item);
    setIsDeleteModalOpen(true);
  };

  const handleToggleActive = async (item, isActive) => {
    try {
      const result = await updateUrlRedirect({
        id: item.id,
        data: { isActive },
      });
      if (result?.error) {
        toast.error(result.error?.data?.message || "Failed to update redirect");
        return;
      }
      toast.success(isActive ? "Redirect activated" : "Redirect deactivated");
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
      {selectedItem && (
        <RedirectDeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          selectedItem={selectedItem}
        />
      )}

      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Box>
              <Typography variant="h4">Redirects</Typography>
              <Typography color="text.secondary" sx={{ mt: 1 }}>
                Send old URLs to the new Buying Guides pages. 301 is permanent,
                302 is temporary. Inactive redirects are kept but not applied.
              </Typography>
            </Box>
            <Button
              color="inherit"
              startIcon={
                <SvgIcon fontSize="small">
                  <ArrowUpOnSquareIcon />
                </SvgIcon>
              }
              variant="contained"
              component={Link}
              to="/redirects/create"
            >
              Add
            </Button>
          </Stack>

          <CustomersSearch search={search} setSearch={setSearch} />

          <RedirectListing
            isLoading={isLoading || isFetching}
            error={error}
            data={data?.data}
            rowCountState={rowCountState}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            onSelectDelete={handleSelectDelete}
            onToggleActive={handleToggleActive}
          />
        </Stack>
      </Container>
    </Box>
  );
}
